const inviteData = [
    {
        fullnames: "Arinze Chinemelum",
        status: "Active",
    },
    {
        fullnames: "Vlad Klitchkov",
        status: "Pending",
    },
    {
        fullnames: "Victoria Akomor",
        status: "Active",
    },
    {
        fullnames: "Timbet Ekanem",
        status: "Declined",
    },

];


export default inviteData
